<!--src/components/footer/CommonFooter.vue-->
<script setup>

</script>

<template>
  <!--底部区域开始-->
  <div class="footer container-fluid g-0">
    <div class="footer-in container">
      <h3>不折不购-专注省钱 | https://www.buzhebugou.com</h3>
      <h2>
        一个专注寻找隐藏优惠券，让您购物折上折的网站。商品涵盖家电
        、手机、电脑、3C数码、母婴、服装、美妆、百货、珠宝等品类，各大电商平台都可找到隐藏优惠
      </h2>
      <ul class="safe">
        <li>
          <a
            href="https://www.creditchina.gov.cn/"
            class="zhengxin"
            target="_blank"
          />
        </li>
        <li>
          <a
            href="https://www.12377.cn/"
            class="jvbao"
            target="_blank"
          />
        </li>
        <li>
          <a
            href="https://im-synthesize.ctrip.com/complaints/rights/AppealCreate"
            class="weiquan"
            target="_blank"
          />
        </li>
        <li>
          <a
            href="https://www.creditchina.gov.cn/"
            class="chengxin"
            target="_blank"
          />
        </li>
      </ul>
      <p class="footer-end">
        <i class="police_logo" />

        <a
          href="https://beian.mps.gov.cn/#/query/webSearch?code=31011502404852"
          rel="noreferrer"
          target="_blank"
        >沪公网安备31011502404852号</a>
        <a
          href="https://beian.mps.gov.cn/#/query/webSearch?code=31011502404852"
          target="_blank"
        >沪ICP备2025153472号-1</a>
      </p>
      <p class="text-muted">
        © 2025 不折不购 版权所有
      </p>
    </div>
  </div>
  <!--底部区域结束-->
</template>

<style scoped lang="scss">
@import "@/assets/css/mixin.scss";
.footer {
  width: 100%;
  background: #faf3fc;
  .footer-in {
    border-radius: 15px;
    box-shadow: 0 4px 8px rgba(220, 53, 69, 0.1) !important;
    //height: 200px;
    background: white;
    padding: 10px;
    margin: 0 auto;
    h3 {
      display: inline-block;
      margin: 10px;
      font-size: 18px;
      color: #4c4c4c;
      font-weight: bold;
    }
    h2 {
      margin-left: 10px;
      font-size: 14px;font-weight: bold;
      color: #4c4c4c;
      padding-bottom: 10px;
    }
    ul{
      //margin-top: 20px;
      padding-top: 20px;
      box-sizing: border-box;
      width: 95%;
      //height: 40px;
      border-top: 1px solid #ccc;
      text-align: center;
      line-height: 40px;
      display: flex;
      justify-content: center;
      //background: #3498db;
      li{
        line-height: 40px;
        padding-right: 10px;
        a{
          width: 100px;
          height: 30px;
          background-color: #e2e2e2;
          display: inline-block;
        }
        &:nth-child(1) a{
          background: url("../../../public/images/beian_list.png") no-repeat 0 -300px;
        }
        &:nth-child(2) a{
          background: url("../../../public/images/beian_list.png") no-repeat 0 -193px;
        }
        &:nth-child(3) a{
          width: 50px;
          background: url("../../../public/images/beian_list.png") no-repeat 0 -353px;
        }
        &:nth-child(4) a{
          width: 92px;
          background: url("../../../public/images/beian_list.png") no-repeat 0 -50px;
        }
      }
    }
    .safe{
      margin: 0 10px !important;
    }
    .footer-end{
      //margin-top: 25px;
      padding-top: 15px;
      width: 100%;
      line-height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    p{
      text-align: center;
    }
    a{
      display: inline-block;
      color: #4c4c4c;
      font-size: 14px;
      padding:0 5px;
      :hover{
        color: red;
      }
    }
    i{
      display: inline-block;
      width: 20px;
      height: 20px;
      background: url("../../../public/images/备案图标.png") no-repeat;
      background-size: 100% auto;
    }
  }
}

// 小屏适配
@media (max-width: 991.98px) {
  .footer{
    .footer-in{
      h3{
        font-size: 16px;
      }
      h2{
        font-size: 12px;
        color: #888888;
      }
      p{
        font-size: 12px;
      }
      a{
        font-size: 12px;
      }
      i{
        width: 18px;
        height: 18px;
      }
    }
  }
}
</style>
